import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { fetchOccupations } from 'src/services/users-service';

interface IOccupationFilterProps {
    onOccupationChange: (occupationId: string) => void;
    label: string;
}

export const OccupationFilter = ({ onOccupationChange, label }: IOccupationFilterProps) => {
    const [occupations, setOccupations] = useState<{id:string, text: string}[]>([]);
    const [ocupationSelected, setOccupationSelected] = useState<string>('');
  
    const fetchOccupationsList = async () => {
      const res = await fetchOccupations();
      if (res.result === 'ok') {
        setOccupations(res.data);
      } else {
        console.log('error:', res.message);
        toast(res.message, { type: 'error' });
      }
    }
  
    useEffect(() => {
      fetchOccupationsList();
    }, []);
  
    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
      const value = e.target.value;
        onOccupationChange(value);
        setOccupationSelected(value);
    }
  
    return (
      <div>
        <div>
          <span className="text-muted">{label}:</span>
        </div>
        <select 
            className={`form-control`}
            name="occupations"
            style={{ width: '220px' }}
            onChange={handleChange}
            value={ocupationSelected || ''}
        >
            <option value={''}>All Occupations</option>
            {
                occupations.map((item, index) => (
                    <option key={index} value={item.id}>{item.text}</option>
                ))
            }
        </select>
      </div>
    );
  }
